export const locale = {
    lang: "en",
    data: {
        COMPONENT: {
            NoiseLevel: "Noise Level",
            Battery: "Battery",
            Octave: "Octave Spectra",
            Average5: "5 minutes average",
            Average30: "30 minutes average",
            NoData: "No data yet",
            DeviceDisconnected: "Make sure device is connected",
            DeviceOffline: "This device is offline",
            CellularSignalLevel: "Cellular Signal Level",
            FreeStorage: "Free Storage",
            PowerSupplyOn: "Plugged in",
            PowerSupplyOff: "On battery",
            TooltipMax: "max",
        },
        EVENTS: {
            Events: "Events",
            Severity: "Severity",
            Type: "Type",
            Device: "Device",
            StartTime: "Start Time",
            EndTime: "End Time",
            Description: "Description",
            Remove: "Remove",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            EventType: "Event type: ",
            NewEvent: "New Event",
            EventDetail: "Event Detail",
            EventTimeError: "End date must be after start date",
            Alarm: "Alarm",
            AckUser: "Ack by",
            Ack: "Acknowledge event",
            AckAll: "Acknowledge all matching events",
        },
        SEVERITY: {
            alarm: "Alarm",
            info: "Information",
            success: "Success",
            warning: "Warning",
        },
        TYPE: {
            device_alarm_off: "Alarm Off",
            device_alarm_on: "Alarm On",
            device_added: "Device Added",
            device_offline: "Device Offline",
            device_online: "Device Online",
            device_plugged: "Device Plugged",
            device_removed: "Device Removed",
            device_unplugged: "Device Unplugged",
            user_defined: "User Defined",
            device_warning_off: "Warning Off",
            device_warning_on: "Warning On",
            device_first_data: "First Device Data",
        },
        ALARM: {
            ID: "Id",
            Name: "Name",
            Description: "Description",
            TimeWindow: "Time Window",
            Threshold: "Threshold",
            Limit: "Limit",
            Severity: "Severity",
            Field: "Field",
            Remove: "Remove",
            Duplicate: "Duplicate",
            time_window_instant: "Instant",
            time_window_bucket_5: "5 minutes bucket",
            threshold_cross_over: "Cross OVER",
            threshold_cross_below: "Cross BELOW",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            AlarmDetail: "Alarm Detail",
            NewAlarm: "New Alarm",
            Notify: "Notify",
            Notification: "Notification",
            Silent: "Silent",
            NeedACK: "Need ACK",
            NewNotificationItem: "email/phone",
            IgnoredDevices: "Ignored Devices",
        },
        FIELD: {
            sound_pressure_level: "Sound Pressure (dBA)",
            sound_pressure_level_c: "Sound Pressure (dBC)",
            sound_pressure_level_1m: "Sound Pressure (dBA, 1 min)",
            sound_pressure_level_1m_sensor_2: "Sound Pressure (Sensor 2)",
            sound_pressure_level_c_1m: "Sound Pressure (dBC, 1 min)",
            sound_pressure_level_c_minus_a: "dBC - dBA",
            rolling_5s: "Rolling 5 seconds (dBA)",
            rolling_5s_c: "Rolling 5 seconds (dBC)",
            rolling_5: "Rolling 5 minutes (dBA)",
            rolling_5_c: "Rolling 5 minutes (dBC)",
            rolling_30: "Rolling 30 minutes (dBA)",
            rolling_30_c: "Rolling 30 minutes (dBC)",
            battery: "Battery",
            power_supply_status: "Power Supply",
            spectrum_13_octave: "1/3 Octave Spectrum",
            spectrum_13_octave_1m: "1/3 Octave Spectrum (1 min)",
            temperature: "Ext. Temperature",
            overload: "Overload",
            underrange: "Underrange",
            wifi_signal_level: "WiFi Signal",
            cellullar_signal_level: "Cellular Signal",
            free_storage: "Free Storage",
        },
    },
};
